import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { switchMap, catchError, tap } from 'rxjs/operators';
import {
    GetChangeOffersEligibleList,
    GetChangeOffersEligibleListFailure,
    GetChangeOffersEligibleListSuccess,
    EChangeOffersEligibleListActions
} from '../actions/change-offers-eligible-list.actions';

import { Store } from '@ngrx/store';
import { OfferVitrineService } from '../../services/offer-vitrine.service';
import { AbstractEffects } from '../../abstract.effects';
import { HttpErrorResponse } from '@angular/common/http';
import { VitrineOfferInterface } from '../../models/vitrine-offer.interface';

@Injectable()
export class ChangeOffersEligibleListEffects extends AbstractEffects {

    constructor(
      private offerVitrineService: OfferVitrineService,
      private actions: Actions,
      public override store: Store<any>
    ) {
        super(store);
    }

    phoneNumber: string;
    offerId: number;

    getChangeOffersEligibleList = createEffect(() =>  this.actions.pipe(
        ofType<GetChangeOffersEligibleList>(EChangeOffersEligibleListActions.GetChangeOffersEligibleList),
        tap(params => {
            this.phoneNumber = params.phoneNumber;
            this.offerId = params.offerId;
        }),
        switchMap(() => this.offerVitrineService.changeOffersEligibleList(this.offerId, this.phoneNumber)),
        switchMap((response: Array<VitrineOfferInterface>) => of(new GetChangeOffersEligibleListSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetChangeOffersEligibleList(this.offerId, this.phoneNumber));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetChangeOffersEligibleListFailure());
            }
            return throwError(error);
        })
    ));
}
